export default __webpack_public_path__ + "static/media/custom-period.b35db80f.svg";